
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/marketing-teams",
      function () {
        return require("private-next-pages/solutions/marketing-teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/marketing-teams"])
      });
    }
  